import { PartnerOrganizationMemberRole, PartnerOrganizationType, } from '@lucidlink/dto/validation';
export const hasPartnerOrganizationsForMigration = (currentUser) => {
    const partnerOrganizations = currentUser?.partnerOrganizations ?? [];
    return partnerOrganizations.some((org) => org.role === PartnerOrganizationMemberRole.OWNER &&
        org.type === PartnerOrganizationType.REGULAR);
};
